<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="800px">
    <v-card>
      <v-card-title>
        {{ isEdit ? $t("candidates.editTitle") : $t("candidates.addTitle") }}
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="$emit('save', { ...form })">
          <v-container>
            <v-row>
              <v-col v-if="showCompanySelect" cols="12">
                <v-autocomplete
                  :label="$t('candidates.form.company')"
                  v-model="form.company_id"
                  :items="companies"
                  item-title="company_name"
                  item-value="id"
                  :rules="[rules.required]"
                  outlined
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.firstName')" v-model="form.FirstName" :rules="[rules.required]" outlined required />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.lastName')" v-model="form.LastName" :rules="[rules.required]" outlined required />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.phone')" v-model="form.PhoneNumber" :rules="[rules.required]" outlined required />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.email')" type="email" v-model="form.Email" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.country')" v-model="form.Country" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.address')" v-model="form.Address" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.marriageStatus')" v-model="form.MarriageStatus" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.children')" v-model="form.Children" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.profession')" v-model="form.Profession" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.dob')" type="date" v-model="form.Dateofbirth" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.nationality')" v-model="form.Nationality" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.specialization')" v-model="form.Specialization" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.lookingPosition')" v-model="form.LookingPosition" outlined />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field :label="$t('candidates.form.cvSource')" v-model="form.CVSource" outlined />
              </v-col>
              <v-col cols="12" md="4"><v-checkbox :label="$t('candidates.form.contacted')" v-model="form.CandidateContacted" /></v-col>
              <v-col cols="12" md="4"><v-checkbox :label="$t('candidates.form.interested')" v-model="form.InterestedInOffers" /></v-col>
              <v-col cols="12" md="4"><v-checkbox :label="$t('candidates.form.hasCv')" v-model="form.HasCV" /></v-col>
              <v-col cols="12" md="12"><v-textarea :label="$t('candidates.form.about')" v-model="form.AboutCandidate" outlined /></v-col>
              <v-col cols="12">
                <v-btn color="primary" type="submit">{{ $t("app.actions.save") }}</v-btn>
                <v-btn variant="text" @click="$emit('update:modelValue', false)">{{ $t("app.actions.cancel") }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";

// Add/edit candidate dialog extracted from Candidati.vue. Keeps a local working
// copy of the record so cancelling never mutates the parent's editCandidate, and
// emits the final payload via `save`. Behaviour (validation, fields) is unchanged.
export default defineComponent({
  name: "CandidateFormDialog",
  props: {
    modelValue: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    candidate: { type: Object, default: () => ({}) },
    // Selector de companie afișat doar pentru admin la adăugarea unui candidat.
    companies: { type: Array, default: () => [] },
    showCompanySelect: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "save"],
  data() {
    return {
      form: { ...this.candidate },
      rules: {
        required: (value) => !!value || this.$t("crm.comments.required"),
      },
    };
  },
  watch: {
    modelValue(open) {
      if (open) this.form = { ...this.candidate };
    },
    candidate(next) {
      if (this.modelValue) this.form = { ...next };
    },
  },
});
</script>
